function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
var PREFIX = 'PageTitle';
var classes = {
  titleStyles: "".concat(PREFIX, "-titleStyles")
};
var StyledTypography = styled(Typography)(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({}, "&.".concat(classes.titleStyles), {
    fontSize: '40px',
    fontWeight: '300',
    letterSpacing: '1.33px',
    color: theme.palette.font.secondary
  });
});
var PageTitle = function PageTitle(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement(StyledTypography, {
    className: classes.titleStyles
  }, children);
};
export default PageTitle;